import { render } from "./EnbEmpty.vue?vue&type=template&id=7486b11c&scoped=true"
import script from "./EnbEmpty.vue?vue&type=script&lang=js"
export * from "./EnbEmpty.vue?vue&type=script&lang=js"

import "./EnbEmpty.vue?vue&type=style&index=0&id=7486b11c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7486b11c"]])

export default __exports__